<template>
  <div class="py-32">
    <Container>
      <div>
        <h1
          class="text-4xl md:text-5xl font-bold mb-12 text-gray-900 dark:text-white"
        >
          {{ t("legal.cgv.title") }}
        </h1>

        <div
          class="prose dark:prose-invert max-w-none space-y-8 text-gray-600 dark:text-gray-300"
        >
          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s1_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s1_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s2_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s2_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s3_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s3_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s4_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s4_content1") }}
            </p>
            <p>
              {{ t("legal.cgv.s4_content2") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s5_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s5_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s6_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s6_content") }}
            </p>
          </section>

          <section>
            <h2
              class="text-2xl font-semibold text-gray-900 dark:text-white mb-4"
            >
              {{ t("legal.cgv.s7_title") }}
            </h2>
            <p>
              {{ t("legal.cgv.s7_content") }}
            </p>
          </section>

          <div
            class="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700 text-sm text-gray-500"
          >
            {{ t("legal.cgv.updated") }}
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
useSeoMeta({
  title: `${t("legal.cgv.title")} - xPirience`,
  description: t("legal.cgv.updated"),
});
</script>
